function asObject(value: unknown): Record<string, unknown> | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  return value as Record<string, unknown>
}

function pushPart(parts: string[], value: unknown, label?: string) {
  if (typeof value !== 'string') return
  const trimmed = value.trim()
  if (!trimmed) return
  parts.push(label ? `${label}: ${trimmed}` : trimmed)
}

export function formatSyncErrorDetails(error: unknown): string {
  if (error instanceof Error && error.message) return error.message

  const record = asObject(error)
  if (!record) return String(error ?? 'Unknown sync error')

  const parts: string[] = []
  pushPart(parts, record.message)
  pushPart(parts, record.code, 'code')
  pushPart(parts, record.details, 'details')
  pushPart(parts, record.hint, 'hint')
  pushPart(parts, record.error_description, 'description')
  pushPart(parts, record.statusCode, 'status')
  pushPart(parts, record.status, 'status')

  if (parts.length > 0) return parts.join(' | ')

  try {
    return JSON.stringify(record)
  } catch {
    return String(error ?? 'Unknown sync error')
  }
}
